import React from 'react'
import { ErrorBoundary as ReactErrorBoundary, ErrorBoundaryProps } from 'react-error-boundary'
import { Analytics } from 'hooks/useAnalytics'

export type { FallbackProps } from 'react-error-boundary'

const handleError = (error: Error) => {
    console.error('[ErrorBoundary] Error:', error)

    // Track the error with RudderStack
    Analytics.getInstance().track('runtime_error_boundary_triggered', {
        error_message: error.message,
        error_stack: error.stack,
        error_name: error.name,
        page_location: window.location.href,
        page_title: document.title,
        timestamp: new Date().toISOString(),
    })
}

type Props = ErrorBoundaryProps

export const ErrorBoundary = (props: Props) => (
    <ReactErrorBoundary onError={handleError} {...props} />
)
